export const SET_NAVBAR_PAGES = "SET_NAVBAR_PAGES";
export const SET_NAVBAR_SETTINGS = "SET_NAVBAR_SETTINGS";
export const SET_DELETE_SETTINGS = "SET_DELETE_SETTINGS";
export const UPDATE_NAVBAR = "UPDATE_NAVBAR";
